"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
// Diagnostic tool progress
const launchEvent = e => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const questionId = e.data.questionId;
    if (!questionId)
        return;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    window.adobeDataLayer.push({
        component: {
            diagnosticTool: null,
        },
    });
    const analyticsEvent = {};
    // Handle subattributes and set in the answer node
    if (((_b = (_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.subattributes) === null || _b === void 0 ? void 0 : _b.length) > 1) {
        analyticsEvent.event = 'diagnosticToolCompletion(all at once)',
            analyticsEvent.component = {
                diagnosticTool: {
                    quizInfo: ((_c = e === null || e === void 0 ? void 0 : e.data) === null || _c === void 0 ? void 0 : _c.quizInfo) || 'NA',
                    quesAns: (_d = e === null || e === void 0 ? void 0 : e.data) === null || _d === void 0 ? void 0 : _d.subattributes,
                }
            };
        analyticsEvent.label = `${e.data.label} `; //'Question <number>'
        analyticsEvent.action = ((_e = e.data) === null || _e === void 0 ? void 0 : _e.action) ? e.data.action : window.ctConstants.diagtoolcta;
    }
    else {
        if (((_g = (_f = e === null || e === void 0 ? void 0 : e.data) === null || _f === void 0 ? void 0 : _f.subattributes) === null || _g === void 0 ? void 0 : _g.length) === 1) {
            analyticsEvent.event = 'diagnosticToolProgress';
            analyticsEvent.component = {
                diagnosticTool: {
                    quizInfo: ((_h = e === null || e === void 0 ? void 0 : e.data) === null || _h === void 0 ? void 0 : _h.quizInfo) || 'NA',
                    step: e.data.label || 'NA',
                    question: e.data.questionText || 'NA',
                    answer: e.data.subattributes
                        .reduce((t, c) => {
                        t.push(c.DTAns);
                        return t;
                    }, [])
                        .toString() || 'NA',
                },
            };
        }
    }
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
